import { on } from "@ngrx/store";
import { SuperUserState } from "../super-user.state";
import { InterestRatesActions } from "./interest-rates.actions";
import { PagesStore } from "../../../pages.state";

// **************************************************************************
// HELPER: Update superUser state within PagesStore
// **************************************************************************

function withSuperUser(state: PagesStore, updater: (superUser: SuperUserState) => SuperUserState): PagesStore {
    return { ...state, superUser: updater(state.superUser) };
}

// **************************************************************************
// INTEREST RATES REDUCER
// Handles operation states only - data is in application/data store
// **************************************************************************

const updateInterestRate = on(InterestRatesActions.updateInterestRate, (state: PagesStore) => withSuperUser(state, superUserState => ({
    ...superUserState,
    interestRates: { ...superUserState.interestRates, updating: true },
    error: null,
})));

const updateInterestRateSuccess = on(InterestRatesActions.updateInterestRateSuccess, (state: PagesStore) => withSuperUser(state, superUserState => ({
    ...superUserState,
    interestRates: { ...superUserState.interestRates, updating: false },
    error: null,
})));

const updateInterestRateFailure = on(InterestRatesActions.updateInterestRateFailure, (state: PagesStore, { error }) => withSuperUser(state, superUserState => ({
    ...superUserState,
    interestRates: { ...superUserState.interestRates, updating: false },
    error,
})));

export const interestRatesReducer = [
    updateInterestRate,
    updateInterestRateSuccess,
    updateInterestRateFailure,
];
